module.exports = __webpack_public_path__ + "img/btn_delete_append.50b51e8f.svg";